


















































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import KendoChart from '@/components/kendo-chart/kendo-chart.vue';

import {IData, IGoalVsRegistration, OrderGroupEnum} from '@/modules/business-plan/modules/report/types';
import {GoalVsRegistrationType} from '@/modules/business-plan/modules/models/enums/goalVsRegistrationType';
import {TupleDictionary} from '@/utils/tupleDictionary';

@Component({
  name: 'TableChartGoalRegistration',
  components: { KendoChart }
})
export default class TableChartGoalRegistration extends Vue {
  public OrderGroupEnum = OrderGroupEnum;

  @Prop({required: true})
  public storeValue: IGoalVsRegistration;

  @Prop({required: true})
  public dictData: TupleDictionary<OrderGroupEnum, IData[]>;

  @Prop({required: true})
  public format: string;

  @Prop({required: true})
  public dataSource: string;

  public get endMonthRegistration() : number {
    return  this.storeValue.values
      .filter(x => x.typeInformation === GoalVsRegistrationType.Registration)
      .maxValueBy(x => x.monthReference);
  }

  public get goalVsRegistrationChart(): any {
    return [{
      goal: this.storeValue.values
        .filter(x => x.typeInformation === GoalVsRegistrationType.Goal && x.monthReference <= this.endMonthRegistration)
        .sumBy(x => x.value),
      registration: this.storeValue.values.filter(x => x.typeInformation === GoalVsRegistrationType.Registration).sumBy(x => x.value),
    }];
  }

  public get goalVsTendencyChart(): any {
    return [{
      goal: this.storeValue.values.filter(x => x.typeInformation === GoalVsRegistrationType.Goal).sumBy(x => x.value),
      registration: this.storeValue.values.filter(x => x.typeInformation === GoalVsRegistrationType.Registration).sumBy(x => x.value)
        + this.storeValue.values.filter(x => x.typeInformation === GoalVsRegistrationType.Tendency).sumBy(x => x.value),
    }];
  }

  public goalVsRegistrationPerGroupChart(group: OrderGroupEnum): any {
    return this.dictData.get(group)
      .filter(data => data.id !== -1)
      .map(data => {
        return {
          name: data.name,
          goal: data.getValue(this.storeValue.values, GoalVsRegistrationType.Goal),
          registration: data.getValue(this.storeValue.values, GoalVsRegistrationType.Registration)
        };
      });
  }
}
